import { FC, useEffect, useState } from 'react';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Box,
	TextField,
	Autocomplete,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getAvailableEmsOptions, getPartners } from 'redux/reducers/referrals/selectors';
import { getEMerchant } from 'redux/reducers/monthlyFee/selectors';
import { TEMManagementRow } from 'components/EMManagement/types';
import { getEMerchantRequest } from 'redux/reducers/monthlyFee/reducer';
import {
	createReferralPartnersRequest,
	getAvailableEmsRequest,
	getPartnersRequest,
} from 'redux/reducers/referrals/reducer';
import { IRequestWithPageSortFilterSearch } from 'redux/types';

export const AddReferralDialog: FC<{
	open: boolean;
	onClose: () => void;
	title: string;
	id?: number;
	updatePageRequestData: IRequestWithPageSortFilterSearch;
}> = ({ open, onClose, title = 'Add Referral', id, updatePageRequestData }) => {
	const dispatch = useDispatch();

	const [partnerId, setPartnerId] = useState<number | null>(null);
	const [partnerError, setPartnerError] = useState<string | null>(null);
	const [emId, setEmId] = useState<number | null>(id ?? null);
	const [emError, setEmError] = useState<string | null>(null);

	const validate = () => {
		let error = false;
		if (!partnerId) {
			setPartnerError('Partner is required');
			error = true;
		} else {
			setPartnerError(null);
		}
		if (!emId) {
			setEmError('EM is required');
			error = true;
		} else {
			setEmError(null);
		}
		return error;
	};

	const reset = () => {
		setPartnerId(null);
		setPartnerError(null);
		setEmId(null);
		setEmError(null);
	};

	const handleClose = () => {
		reset();
		onClose();
	};

	const handleSave = () => {
		const error = validate();
		if (error || !partnerId || !emId) {
			return;
		}
		dispatch(
			createReferralPartnersRequest({
				body: { partnerId, emId },
				referralPartnersResponse: updatePageRequestData,
			}),
		);
		handleClose();
	};

	const partners = useSelector(getPartners);
	console.log('partners', partners);
	const partnersOptions = partners?.data?.map(partner => ({
		id: partner.id,
		name: partner.partnerName,
	}));
	const emsOptions = useSelector(getAvailableEmsOptions);

	useEffect(() => {
		if (!open) return;
		dispatch(getPartnersRequest({ pageNumber: 1, pageSize: 10000 }));
		dispatch(getAvailableEmsRequest());
	}, [dispatch, open]);

	return (
		<Dialog open={open} onClose={handleClose}>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				<Box
					sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '500px', marginTop: 2 }}
				>
					<Autocomplete
						options={partnersOptions ?? []}
						getOptionLabel={option => option.name}
						onChange={(e, value) => {
							setPartnerId(value?.id ?? null);
							setPartnerError(null);
						}}
						fullWidth
						renderInput={params => (
							<TextField
								{...params}
								label="Partner"
								error={!!partnerError}
								helperText={partnerError}
							/>
						)}
					/>
					<Autocomplete
						options={emsOptions ?? []}
						getOptionLabel={option => option.fullName}
						onChange={(e, value) => {
							setEmId(value?.id ?? null);
							setEmError(null);
						}}
						fullWidth
						renderInput={params => (
							<TextField {...params} label="EM" error={!!emError} helperText={emError} />
						)}
					/>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Cancel</Button>
				<Button onClick={handleSave} color="primary">
					Add Referral
				</Button>
			</DialogActions>
		</Dialog>
	);
};
